module.exports = __webpack_public_path__ + "static/media/header-back.cb1c6710.jpg";